import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { IntraoccularPressureRightEyeAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface IntraoccularPressureRightEyeActionFormGroup {
	iop: FormControl<UnitQuantity | null>;
}

@Component({
    selector: 'app-intraoccular-pressure-right-eye-action-controls',
    templateUrl: './intraoccular-pressure-right-eye-action-controls.component.html',
    styleUrls: ['../../../common.scss', './intraoccular-pressure-right-eye-action-controls.component.scss'],
    imports: [CommonActionControlsComponent, ActionFormComponent, UnitQuantityControl, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntraoccularPressureRightEyeActionControlsComponent implements SheetActionControlsBase {

	slot!: Slot | null;
	action!: IntraoccularPressureRightEyeAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as IntraoccularPressureRightEyeAction;
	}

	@Input() form!: FormGroup<IntraoccularPressureRightEyeActionFormGroup>;
	@Input() item!: Row | null;
	
	constructor(private formBuilder: FormBuilder) {
	}

  	ngOnInit(): void {
      	this.form.addControl('iop', this.formBuilder.control(this.action?.iop ?? null));
  	}
}